var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSelect(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "select icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Select/unselect-products",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01.1_Select-and-unselect-products",
    transform: "translate(-779.000000, -249.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "products",
    transform: "translate(16.000000, 240.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "image-hover",
    transform: "translate(754.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "product-bar"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.203125,23.515625 C22.765625,23.515625 23.5625,22.7265625 23.5625,21.1796875 L23.5625,12.1640625 C23.5625,10.625 22.765625,9.8359375 21.203125,9.8359375 L12.2421875,9.8359375 C10.6796875,9.8359375 9.8828125,10.6171875 9.8828125,12.1640625 L9.8828125,21.1796875 C9.8828125,22.7265625 10.6796875,23.515625 12.2421875,23.515625 L21.203125,23.515625 Z M21.15625,22.2265625 L12.2890625,22.2265625 C11.5703125,22.2265625 11.171875,21.84375 11.171875,21.09375 L11.171875,12.25 C11.171875,11.5 11.5703125,11.125 12.2890625,11.125 L21.15625,11.125 C21.8671875,11.125 22.2734375,11.5 22.2734375,12.25 L22.2734375,21.09375 C22.2734375,21.84375 21.8671875,22.2265625 21.15625,22.2265625 Z M15.796875,20.3671875 C16.0546875,20.3671875 16.2578125,20.25 16.4140625,20.0078125 L20.0546875,14.3046875 C20.1484375,14.15625 20.234375,13.9921875 20.234375,13.8203125 C20.234375,13.46875 19.9296875,13.25 19.6015625,13.25 C19.3984375,13.25 19.203125,13.3671875 19.0625,13.6015625 L15.765625,18.8671875 L14.0703125,16.6875 C13.8984375,16.46875 13.7265625,16.3828125 13.515625,16.3828125 C13.1796875,16.3828125 12.90625,16.65625 12.90625,17 C12.90625,17.171875 12.9765625,17.3359375 13.0859375,17.4765625 L15.140625,20.015625 C15.3515625,20.2578125 15.546875,20.3671875 15.796875,20.3671875 Z",
    id: "select-icon"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSelect);
export default __webpack_public_path__ + "static/media/icon_select.947ad6fd.svg";
export { ForwardRef as ReactComponent };